import { useState } from 'react';
import { Check, Crown, SketchLogo, X } from '@phosphor-icons/react';
import { Flex } from 'antd';
import PayCode from '../PluginPay/PayModal/payCode';
import { AmountObject, VIPType } from '~/services/pay';

import './index.less';

interface VipPlan {
  key: VIPType;
  title: string;
  price: number;
  originalPrice: number;
  isSvip?: boolean;
}

const vipPlans: VipPlan[] = [
  {
    key: 'SVIP_YEAR',
    title: 'SVIP年卡',
    price: 398,
    originalPrice: 1980,
    isSvip: true,
  },
  {
    key: 'SVIP_MONTH',
    title: 'SVIP月卡',
    price: 59,
    originalPrice: 590,
    isSvip: true,
  },
  {
    key: 'VIP_YEAR',
    title: 'VIP年卡',
    price: 199,
    originalPrice: 399,
  },
];

const featureList = [
  '积分消耗享更优折扣',
  '解锁工作流复制功能',
  '可迁移所有SVIP工作流',
  '提供一对一技术支持服务',
  '扣子插件定制特惠',
  '解锁文件上传功能'
];

const featureCom = [
  {
    key: 'SVIP',
    title: 'SVIP 特权',
    icon: <SketchLogo weight="fill" />,
    features: ['6折', true, true, true, true, true],
  },
  {
    key: 'VIP',
    title: 'VIP 特权',
    icon: <Crown weight="fill" />,
    features: ['8折', true, false, false, false, false],
  },
];

const SVipPay = ({ show = false }: { show?: boolean }) => {
  const [currentSelect, setCurrentSelect] = useState<VipPlan>(vipPlans[0] as VipPlan);

  const handleSelectPlan = (plan: VipPlan) => {
    setCurrentSelect(plan);
  };

  return (
    <Flex className="vippay-container">
      <div className="vippay-type-ct">
        <div className="vip-plans-wrapper">
          {vipPlans.map((plan) => (
            <div
              key={plan.key}
              className={`vip-plan-card ${currentSelect.key === plan.key ? 'active' : ''} ${plan.isSvip ? 'SVIP' : 'VIP'}`}
              onClick={() => handleSelectPlan(plan)}
            >
              <div className="vip-plan-header">
                <div className="vip-plan-title">{plan.title}</div>
              </div>
              <div className="vip-plan-price">
                <div className="vip-price-current">¥{plan.price}</div>
                <div className="vip-price-original">¥{plan.originalPrice}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="vippay-features-ct-wrapper">
          <div className="vippay-features-hr">会员权益对比</div>
          <div className="vippay-features-ct">
            {featureCom.map((item) => (
              <div key={item.key} className={`vippay-features-item ${item.key}`}>
                <Flex className="vippay-features-title" align="center" gap={8}>
                  {item.icon}
                  {item.title}
                </Flex>
                <Flex className="vippay-features-content" vertical gap={8}>
                  {item.features.map((feature, index) => (
                    <Flex
                      key={index}
                      className={`vippay-feature ${feature ? 'exclusive' : 'no'}`}
                      align="center"
                      justify="space-between"
                      gap={4}
                    >
                      <span>{featureList[index]}</span>
                      {feature ? (
                        feature === true ? (
                          <Check weight="bold" color="#52c41a" />
                        ) : (
                          <span className="vippay-feature-text">{feature}</span>
                        )
                      ) : (
                        <X weight="bold" />
                      )}
                    </Flex>
                  ))}
                </Flex>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="vippay-divider"></div>
      <div className="vippay-qrcode-ct">
        <PayCode
          open={show}
          currentSelect={
            {
              key: currentSelect.key,
              value: currentSelect.price,
            } as AmountObject
          }
        />
      </div>
    </Flex>
  );
};

export default SVipPay;
